import { render } from "./Daftar_lama.vue?vue&type=template&id=13809432"
import script from "./Daftar_lama.vue?vue&type=script&lang=js"
export * from "./Daftar_lama.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__